<template>
    <div class="step">
        <div class="step-type">
            <div class="step-title">项目名称：<strong>{{ projectName }}</strong></div>
            <template v-if="showReview">
                <el-button type="" class="" v-if="hasBtnPermission('btn_dgwitness_expert_avoidance_5.0')"
                           @click="handleShowExpertAvoidanceClick()">专家回避情况</el-button>
                <el-button type="" class="" v-if="hasBtnPermission('btn_dgwitness_look_evaluation_result_5.0')"
                    @click="handleClickRoute()">查看评标报告</el-button>
                <el-button type="" class="" @click="reviewProgress(1)">专家评审进度</el-button>
                <el-button type="" class="" @click="reviewProgress(2)">专家评分明细</el-button>
            </template>
            <el-button type="primary" class="step-btn" @click="refreshHandler">刷新进度</el-button>
        </div>
        <div class="step-content" v-if="stepList && stepList.length > 0">
            <div class="step-items">
                <div class="step-item" :class="setClass(item)" v-for="(item, index) in stepList" :key="index">
                    <span class="step-circle">
                        <i v-if="item.taskStatus == '0'" style="font-size: 24px;" class="el-icon-circle-check" />
                        <template v-else>{{ index + 1 }}</template>
                    </span>
                    <span class="step-text">{{ item.actName }}</span>
                    <!-- <span class="step-text" v-if="item.taskStatus">{{'2024-05-06'}}</span> -->
                  <span class="step-time" v-if="item.taskEndTime">{{item.taskEndTime}}</span>
                </div>
            </div>
        </div>
        <expertApplyModal ref="expertApplyRef" @sure="sure" @closed="closed" />
        <expertAvoidanceModal ref="expertAvoidanceRef" />
    </div>
</template>

<script>
import { mapState } from "vuex";
import expertApplyModal from './expertApplyModal'
import expertAvoidanceModal from './expertAvoidanceModal'
export default {
    components: {
        expertApplyModal,
        expertAvoidanceModal
    },
    props: {
        id: {
            type: String,
            default: ''
        },
        projectName: {
            type: String,
            default: ''
        },
        showReview: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            stepList: [],
            params: {},
            name: '',
            user: '',
        }
    },
    computed: {
        ...mapState({
            stateData: state => state.user
        }),
    },
    mounted() {
        console.log('----🚀----', this.hasBtnPermission());


        this.getData()
        this.timer = setInterval(() => {
            this.getData()
        }, 1000 * 60 * 10)
    },
    activated() {
        this.user = this.stateData.pageRoleIds //角色类型
    },
    beforeDestroy() {
        clearInterval(this.timer)
    },
    methods: {
        closed() {
        },
        sure() {
        },
        handleShowExpertAvoidanceClick(){
            const id = this.$route.query.tradePlatfBidSectionId
            if (!id) {
                throw new Error('tradePlatfBidSectionId is required')
            }
            this.$refs.expertAvoidanceRef.init({
                bidSectionId: id || '',
            })

        },
        handleClickRoute() {
            this.$router.push({
                name: "busWitness_detail",
                query: {
                    datasetCode: 'A34', // 评标结果
                    bidSectionCode: this.$route.query.id,
                    queryParams: JSON.stringify(this.$route.query),
                    // businessType: this.businessType,
                    // id: item.id,
                    // purchaserMode: item.purchaserMode || "",
                    // evalcommitteeBuildId: item.evalcommitteeBuildId,
                    // tenderCode: item.businessCode,
                },
            });

            // this.$router.push({
            //     path: "/traddingWitness/openBidWitness/eval_detail/evaluation_result",
            //     query: {
            //         // id: item.bidSectionCode,
            //         // roomCode: item.roomCode,
            //         // dataSource: item.dataSource,
            //         // tradePlatfBidSectionId: item.bidId,
            //         // bidSectionCode: item.bidSectionCode,
            //     },
            // });
        },
        reviewProgress(type) {
            // this.$http.post(`/evaluationProcess/premise`, {
            //     type, ///1专家评审进度 2专家评分明细
            //     bidSectionCode: this.id || this.$route.query.id
            // }).then(res => {
            //     // this.stepList = res.data
            // })
            this.$http.post(`/evaluationProcess/detailVerdict`, {
                bidSectionCode: this.$route.query.id,
                type
            }).then((res) => {
                if (res.data.data) {
                    this.$http.post(`/evaluationProcess/getDetailByCodeAndType`, {
                        bidSectionCode: this.$route.query.id,
                        type
                    }).then((detailRes) => {
                        let obj = detailRes.data.data;
                        this.$router.push({
                            name: "expert_review_detail",
                            query: {
                                businessType: "GC",
                                id: obj.id,
                                purchaserMode: obj.purchaserMode || "",
                                evalcommitteeBuildId: obj.evalcommitteeBuildId,
                                tenderCode: obj.businessCode,
                                tradePlatfBidSectionId: obj.tradePlatfBidSectionId,
                                type: obj.type,
                                bidSectionName: obj.bidSectionName,
                            },
                        });
                    })
                } else {
                    this.$refs.expertApplyRef.apply(1, {
                        bidSectionCode: this.$route.query.id,
                        type
                    })
                }
            });

        },
        refreshHandler() {
            this.getData()
        },
        getData() {
            // todo set stepList
            const id = this.$route.query.tradePlatfBidSectionId
            if (!id) {
                throw new Error('tradePlatfBidSectionId is required')
            }
            this.$http.post(`/evaluation/getpbstatus/${id}`).then(res => {
                this.stepList = res.data
            })
        },
        setClass(item) {
            // 节点状态,0：已完成,1：正在评审,其他：等待中
            let stateEnum = {
                '0': 'item-pass', //已完成
                '1': 'item-cur', //评审中
                '2': 'item-no' //未评审
            }
            return stateEnum[item.taskStatus] || 'item-no';
        },
    },
}
</script>
<style lang="less" scoped>
.step {
    padding: 8px;
    height: 100%;
    background: #fff;

    .step-type {
        display: flex;
        justify-content: space-between;
        align-items: center;

        .step-title {
            width: calc(100% - 200px);
            overflow: hidden;
            /*超出部分隐藏*/
            text-overflow: ellipsis;
            /* 超出部分显示省略号 */
            white-space: nowrap;
            /*规定段落中的文本不进行换行 */
        }

        .step-btn+.step-btn {
            margin-left: 10px;
        }
    }

    .step-content {
        display: flex;
        align-items: center;
        height: 120px;

        .step-btn {
            margin-right: 6px;
        }

        .step-items {
            margin-top: 10px;
            display: flex;
            flex: 1;

            .step-item {
                height: 100%;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: flex-start;
                flex: 1;
                position: relative;

                &:after {
                    content: '';
                    width: calc(100% - 21px);
                    height: 2px;
                    background: #000;
                    position: absolute;
                    top: 12px;
                    left: 50%;
                    transform: translateX(12px);
                }

                &:last-of-type {
                    &:after {
                        display: none;
                    }
                }

                &+.step-item {
                    margin-left: 2px;
                }

                .step-circle {
                    font-size: 12px;
                    font-weight: bold;
                    width: 24px;
                    height: 24px;
                    border: 2px solid #000;
                    border-radius: 50%;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    // line-height: 1;
                    margin-bottom: 4px;
                    position: relative;
                    z-index: 9;
                    overflow: hidden;
                }

                .step-text {
                    width: 100%;
                    text-align: center;
                    padding-bottom: 4px;
                }

                &.item-pass {
                    color: #3AD77E;

                    .step-circle {
                        border-color: #3AD77E;
                    }

                    &:after {
                        background: #3AD77E;
                    }
                }

                &.item-cur {
                    color: #1890ff;

                    .step-circle {
                        border-color: #1890ff;
                    }

                    &:after {
                        background: #1890ff;
                    }
                }

                &.item-no {
                    color: rgba(0, 0, 0, .45);

                    .step-circle {
                        border-color: rgba(0, 0, 0, .45);
                    }

                    &:after {
                        background: rgba(0, 0, 0, .45);
                    }
                }
            }
        }
    }
}
</style>